






















import { computed, defineComponent } from '@vue/composition-api';
import { useStore } from '@/store';
import { MutationTypes } from '@/store/mutations';
import ComparisonRow from '@/components/Comparison/ComparisonRow.vue';

export default defineComponent({
    name: 'ApprovalSchemeRow',
    components: { ComparisonRow },
    setup () {
        const store = useStore();
        const names = computed(() => store.getters.visibleValuesOf(store.state.approvalSchemeNames));
        const logos = computed(() => store.state.approvalSchemeLogos);
        const links = computed(() => store.state.approvalSchemeLinks);

        const openModal = (src: string) => {
            store.commit(MutationTypes.OpenModal, {
                id: 'niau-modal',
                src: src
            });
        };

        return { names, logos, links, openModal };
    }
});
